export enum TipoTela {
    // CORRIGIR = cod de PI e CD
    PLANTA_INDUSTRIAL = 1,
    CENTRO_DISTRIBUICAO = 2,
    SAZONALIDADE= 3,
    MERCADO_EXTERNO = 4 ,
    OTIMIZACAO_RECEITA = 5,
    PRECO_BASE = 6,
    USUARIO = 7,
  }